import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../css/salesorder.css";
import axios from "axios";
import { confirm } from 'devextreme/ui/dialog';
import { GridLayout } from "../../../common/GridLayout";
import data from "../../../assets/apiRoutes.json";
import { SelectBox,TextBox } from 'devextreme-react';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { alert } from 'devextreme/ui/dialog';
import { MESSAGES } from "../../../common/Messages";
import { discardPendingEdits } from "../../../common/dataStore";

import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    Editing,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import AllocateDialog from "./AllocateDialog";
let ItemId = "";
const SearchResults = (props) => {
    // The page owns the ref so its store's onConflict can refresh this grid (rule 16).
    const ownGrid = useRef(null);
    const dataGrid = props.gridRef ?? ownGrid;
    var accessToken = props.accessToken;
    const childRef = useRef();
    const allowedPageSizes = [10, 20, 100, 500];
    const gridKey = "dc96adca-c885-497d-81b8-06753eff86a9";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const [openAllocateDialog, setOpenAllocateDialog] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);

    const onSelectionChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
    };

      useEffect(() => {
        if(selectedRowData || selectedRowData?.detailRowId)
          setOpenAllocateDialog(true);
      }, [selectedRowData]);

    /**
     * Closing the dialog puts the listing back in charge, and by then it is stale: the dialog inserted
     * detail lines and SPOM_DECREMENTDETAILQUANTITY has just reduced the Ordered quantity of the row it was
     * opened from. So re-pull the rows.
     *
     * Discard first. The cell that opened the dialog is still in edit state, and if its save was rejected
     * the failed edit is sitting in `editing.changes` with the error row showing - refresh() clears neither,
     * and leaving the change there means the next thing that closes the cell re-submits the request the
     * server already refused (see dataStore.discardPendingEdits).
     *
     * Clearing selectedRowData is what lets the same row open the dialog again: the effect above keys off
     * that state changing.
     */
    const closeAllocateDialog = useCallback((open) => {
        setOpenAllocateDialog(open);
        if (open) return;

        setSelectedRowData(null);

        const grid = dataGrid.current?.instance?.();
        if (!grid) return;

        discardPendingEdits(grid);
        grid.refresh();
    }, []);

    const deleteRecords = () => {
        // Rule 12: project-standard delete-confirm wording.
        let result = confirm("<i>Delete selected record?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                dataGrid.current.instance().beginCustomLoading("Deleting");
                console.log(selectedItemKeys[0]);
                axios.post
                    (
                        `${window._env_.REACT_APP_APIS}/${data.OM.DeleteDetailTransaction}`,
                        selectedItemKeys,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        dataGrid.current.instance().endCustomLoading();
                        dataGrid.current.instance().refresh();
                    })
                    .catch((err) => {
                        dataGrid.current.instance().endCustomLoading();
                    });
            }
        });

    }
    async function setCode1Value(rowData, value) {
        try {
            rowData.userDefinedCode1 = value;
        } catch (error) {
            console.error("Failed to fetch  Code1 :", error);
        }
    }
    async function setCode2Value(rowData, value) {
        try {
            rowData.userDefinedCode2 = value;
        } catch (error) {
            console.error("Failed to fetch  Code1 :", error);
        }
    }
    async function setCode3Value(rowData, value) {
        try {
            rowData.userDefinedCode3 = value;
        } catch (error) {
            console.error("Failed to fetch  Code1 :", error);
        }
    }
    async function setCode4Value(rowData, value) {
        try {
            rowData.userDefinedCode4 = value;
        } catch (error) {
            console.error("Failed to fetch  Code1 :", error);
        }
    }
    async function setCode5Value(rowData, value) {
        try {
            rowData.userDefinedCode5 = value;
        } catch (error) {
            console.error("Failed to fetch  Code1 :", error);
        }
    }
    const GetCodeByType = (type) => {
        const items = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${data.OM.GetCodeByType}`,
                key: 'rowid',
                loadParams: {
                    codeType: type
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "code", desc: false }],
            paginate: true,
            pageSize: 100
        });
        return items;
    };
    const renderCode1Cell = (cellElement) => {
        const items = GetCodeByType(12)
        const currentValue = cellElement.data.userDefinedCode1;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="code"
                displayExpr="code"
                defaultValue={currentValue}
                acceptCustomValue={true}
                searchEnabled={true}
                searchExpr="Code"
                searchMode="contains"
                onValueChanged={async (e) => {
                    const selectedText = e.component.option('displayValue');
                    ItemId = e.value;
                    cellElement.setValue(selectedText);
                }}
            />
        );
    }
    const addRecord = () => {
        setSelectedRowData([]);
    }
    const renderOrdered = (cellElement) => {
        return (
            <TextBox
                defaultValue={cellElement.data.newquantityorder ?? ""}
                onValueChanged={async (e) => {
                    if(e.value>cellElement.data.quantityOrdered)
                    {
                        alert(MESSAGES.NEW_ORDERED_EXCEEDS_ORDERED, MESSAGES.ERROR);
                        return;
                    }
                    // Commit the typed value into the row. Without this the cell never changes, so
                    // DevExtreme raises no update and - because the dialog reads newquantityorder to
                    // compute Qty Difference and to default the new line's Ordered - the whole difference
                    // flow ran on an undefined quantity.
                    const newOrdered = e.value === "" || e.value === null || e.value === undefined
                        ? null
                        : Number(e.value);
                    cellElement.setValue(newOrdered);

                    // Delphi opens OMD0022 only on SaveModifiableData's QtyChanged, which is
                    // `(not IsNull) and (Value > 0)` (uOMM0021) - clearing the cell or typing 0 is not a
                    // difference to handle, and the service's decrement branch is gated the same way.
                    if (!(newOrdered > 0)) return;
                    setSelectedRowData({ ...cellElement.data, newquantityorder: newOrdered });
                }}
            />
        );
    }
    const renderCode2Cell = (cellElement) => {
        const items = GetCodeByType(13)
        const currentValue2 = cellElement.data.userDefinedCode2;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="code"
                displayExpr="code"
                defaultValue={currentValue2}
                acceptCustomValue={true}
                searchEnabled={true}
                searchExpr="Code"
                searchMode="contains"
                onValueChanged={async (e) => {
                    const selectedText = e.component.option('displayValue');
                    ItemId = e.value;
                    cellElement.setValue(selectedText);
                }}
            />
        );
    }
    const renderCode3Cell = (cellElement) => {
        const items = GetCodeByType(14)
        const currentValue2 = cellElement.data.userDefinedCode3;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="code"
                displayExpr="code"
                defaultValue={currentValue2}
                acceptCustomValue={true}
                searchEnabled={true}
                searchExpr="Code"
                searchMode="contains"
                onValueChanged={async (e) => {
                    const selectedText = e.component.option('displayValue');
                    ItemId = e.value;
                    cellElement.setValue(selectedText);
                }}
            />
        );
    }
    const renderCode4Cell = (cellElement) => {
        const items = GetCodeByType(15)
        const currentValue2 = cellElement.data.userDefinedCode4;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="code"
                displayExpr="code"
                defaultValue={currentValue2}
                acceptCustomValue={true}
                searchEnabled={true}
                searchExpr="Code"
                searchMode="contains"
                onValueChanged={async (e) => {
                    const selectedText = e.component.option('displayValue');
                    ItemId = e.value;
                    cellElement.setValue(selectedText);
                }}
            />
        );
    }
    const renderCode5Cell = (cellElement) => {
        const items = GetCodeByType(16)
        const currentValue2 = cellElement.data.userDefinedCode5;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="code"
                displayExpr="code"
                defaultValue={currentValue2}
                acceptCustomValue={true}
                searchEnabled={true}
                searchExpr="Code"
                searchMode="contains"
                onValueChanged={async (e) => {
                    const selectedText = e.component.option('displayValue');
                    ItemId = e.value;
                    cellElement.setValue(selectedText);
                }}
            />
        );
    }
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                selectedRowKeys={selectedItemKeys}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className={props.searchPanelStatus ? "GridHeightAccordianOpen" : "GridHeightAccordianClose"}
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                onSelectionChanged={onSelectionChanged}
                onRowUpdating={(e) => {
                    // Rule 15: merge the whole previous row, never a field whitelist - that merge is what
                    // carries ConcurrencyToken (and headerRowId) to the server.
                    e.newData = { ...e.oldData, ...e.newData };
                }}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <ColumnHeaderFilter />
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="multiple" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <Editing
                    mode="cell"
                    allowUpdating={true}
                    allowAdding={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <Scrolling mode="standard" />
                <Column
                    dataField="newquantityorder"
                    dataType="number"
                    caption="New Ordered"
                    editCellRender={renderOrdered}
                ></Column>
                <Column dataField="detailRowId" caption='DetailRowId' allowEditing={false} visible={false} ></Column>
                <Column dataField="warehouseIdentityId" caption='Warehouse' allowEditing={false} ></Column>
                <Column dataField="itemCode" caption='Item' allowEditing={false}></Column>
                <Column dataField="lotCode" caption='Lot' allowEditing={false}></Column>
                <Column dataField="transactionNumber" caption='Transaction#' allowEditing={false}></Column>
                <Column dataField="transactionDate" allowEditing={false} caption='Transaction Date' dataType="date" format="MM/dd/yyyy"  ></Column>
                <Column dataField="customerIdentityId" allowEditing={false} caption='Customer' ></Column>
                <Column dataField="quantityOrdered" allowEditing={false} caption='Orderd' format={{
                    type: 'fixedPoint',
                    precision: 2
                }} />
                <Column dataField="quantityShipped" allowEditing={false} caption='Shipped' format={{
                    type: 'fixedPoint',
                    precision: 2
                }} />
                <Column dataField="userDefinedCode1" visible={false} editCellRender={renderCode1Cell} setCellValue={setCode1Value} caption='Code1' >
                </Column>
                <Column dataField="userDefinedCode2" visible={false} editCellRender={renderCode2Cell} setCellValue={setCode2Value} caption='Code2' >
                </Column>
                <Column dataField="userDefinedCode3" visible={false} editCellRender={renderCode3Cell} setCellValue={setCode3Value} caption='Code3' >
                </Column>
                <Column dataField="userDefinedCode4" visible={false} editCellRender={renderCode4Cell} setCellValue={setCode4Value} caption='Code4' >
                </Column>
                <Column dataField="userDefinedCode5" visible={false} editCellRender={renderCode5Cell} setCellValue={setCode5Value} caption='Code5' >
                </Column>
                <Column dataField="userDefinedQuantity1" visible={false} caption='Quantity1' ></Column>
                <Column dataField="userDefinedQuantity2" visible={false} caption='Quantity2' ></Column>
                <Column dataField="userDefinedQuantity3" visible={false} caption='Quantity3' ></Column>
                <Column dataField="userDefinedQuantity4" visible={false} caption='Quantity4' ></Column>
                <Column dataField="userDefinedQuantity5" visible={false} caption='Quantity5' ></Column>
                <Column dataField="userDefinedDate1" dataType="date" format="MM/dd/yyyy" visible={false} caption='Date1' ></Column>
                <Column dataField="userDefinedDate2" dataType="date" format="MM/dd/yyyy" visible={false} caption='Date2' ></Column>
                <Column dataField="userDefinedDate3" dataType="date" format="MM/dd/yyyy" visible={false} caption='Date3' ></Column>
                <Column dataField="userDefinedDate4" dataType="date" format="MM/dd/yyyy" visible={false} caption='Date4' ></Column>
                <Column dataField="userDefinedDate5" dataType="date" format="MM/dd/yyyy" visible={false} caption='Date5' ></Column>
                <Column dataField="userDefinedReference1" visible={false} caption='Reference1' ></Column>
                <Column dataField="userDefinedReference2" visible={false} caption='Reference2' ></Column>
                <Column dataField="userDefinedReference3" visible={false} caption='Reference3' ></Column>
                <Column dataField="userDefinedReference4" visible={false} caption='Reference4' ></Column>
                <Column dataField="userDefinedReference5" visible={false} caption='Reference5' ></Column>
                <Toolbar>
                <Item>
                        <Button
                        type="default"
                            onClick={addRecord}
                            text="Add"
                            />
                    </Item>
                    <Item>
                        <Button
                        type="default"
                            onClick={deleteRecords}
                            text="Delete Selected Records"
                            disabled={!selectedItemKeys.length} />
                    </Item>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>

            {openAllocateDialog && (<AllocateDialog data={selectedRowData} openAllocateDialog={openAllocateDialog} setOpenAllocateDialog={closeAllocateDialog}/>)}
        </div>
    )
};

export default SearchResults;